export default "__VITE_ASSET__CAiiHwU2__"